module.exports = __webpack_public_path__ + "static/media/Dynamo Node Autocomplete.873fa149.png";